const formats = [
  {
    icon: 'ri-flashlight-line',
    title: 'Корпоративный тренинг',
    desc: 'Интенсивная практическая программа на 1–3 дня. Максимум инструментов и отработки в сжатые сроки. Подходит для быстрого развития конкретных управленческих навыков.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Модульная программа',
    desc: 'Несколько обучающих модулей с практикой между встречами. Участники применяют инструменты в работе и возвращаются для разбора результатов и углубления навыков.',
  },
  {
    icon: 'ri-road-map-line',
    title: 'Управленческая программа',
    desc: 'Комплексное развитие руководителей на протяжении нескольких месяцев. Системная работа с диагностикой, обучением, внедрением и оценкой изменений.',
  },
  {
    icon: 'ri-gamepad-line',
    title: 'Бизнес-игры',
    desc: 'Практическая отработка управленческих ситуаций в игровом формате. Высокая вовлечённость, командное взаимодействие и быстрая обратная связь.',
  },
  {
    icon: 'ri-brain-line',
    title: 'Фасилитация',
    desc: 'Работа с управленческой командой для принятия решений и решения сложных вопросов. Структурированное обсуждение с выходом на конкретные договорённости.',
  },
  {
    icon: 'ri-user-voice-line',
    title: 'Коучинг руководителей',
    desc: 'Индивидуальная работа с конкретными управленческими задачами. Помогает руководителю найти собственные решения и развить управленческий стиль.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Сопровождение после обучения',
    desc: 'Разбор реальных ситуаций и поддержка внедрения инструментов в работу. Повышает вероятность того, что навыки закрепятся в практике, а не забудутся.',
  },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как можно развивать управленческие компетенции
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Для разных задач и уровней руководителей подходят разные форматы. Выбор зависит от целей, состава группы и глубины необходимых изменений.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {formats.slice(0, 6).map((fmt, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${fmt.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{fmt.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{fmt.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 flex justify-center">
          <div className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group max-w-md w-full">
            <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
              <i className={`${formats[6].icon} text-xl text-teal-700`}></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">{formats[6].title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">{formats[6].desc}</p>
          </div>
        </div>
      </div>
    </section>
  );
}